import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-slot": "icon",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"i-79477246__a\"><circle cx=\"256\" cy=\"256\" r=\"256\" fill=\"#fff\"></circle></mask><g mask=\"url(#i-79477246__a)\"><path fill=\"#6da544\" d=\"M0 512h167l37.9-260.3L167 0H0z\"></path><path fill=\"#d80027\" d=\"M512 0H167v512h345z\"></path><circle cx=\"167\" cy=\"256\" r=\"89\" fill=\"#ffda44\"></circle><path fill=\"#d80027\" d=\"M116.9 211.5V267a50 50 0 1 0 100.1 0v-55.6H117z\"></path><path fill=\"#eee\" d=\"M167 283.8c-9.2 0-16.7-7.5-16.7-16.7V245h33.4v22c0 9.2-7.5 16.7-16.7 16.7z\"></path></g>", 2)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "portugese"}) } }